import { AnnouncementDto } from '@careapp-group/ng-sdk-v2-new';
import { ModelEventDto } from '@careapp-group/ng-sdk-v2-new/model/modelEventDto';
import { createAction, props } from '@ngrx/store';
import { CareAppListActionFactory, PayloadAction } from '../action-factory';

export const RECENTLY_VIEWED = 'recentlyViewed';

export interface AnnouncementRequest extends AnnouncementDto {
  existingFileIds?: Array<string>;
}

class AnnouncementActions extends CareAppListActionFactory<AnnouncementDto> {
  get REQUEST_TOTAL_COUNT() {
    return `[${this.type}][Request] Total Count for Organisation`;
  }

  get RESPONSE_SUCCESS_TOTAL_COUNT() {
    return `[${this.type}][Response][Success] Total Count for Organisation`;
  }

  get RESPONSE_FAIL_TOTAL_COUNT() {
    return `[${this.type}][Response][Fail] Total Count for Organisation`;
  }

  get PROMPT_CREATE() {
    return `[${this.type}][Prompt] Create`;
  }

  get PROMPT_EDIT() {
    return `[${this.type}][Prompt] Edit`;
  }

  get PROMPT_DELETE() {
    return `[${this.type}][Prompt] Delete`;
  }

  get REQUEST_LOG_VIEW() {
    return `[${this.type}][Request] Log View`;
  }
  get RESPONSE_SUCCESS_LOG_VIEW() {
    return `[${this.type}][Response][Success] Log View`;
  }
  get RESPONSE_FAIL_LOG_VIEW() {
    return `[${this.type}][Response][Fail] Log View`;
  }

  get REQUEST_HISTORY() {
    return `[${this.type}][Request] Get History`;
  }
  get RESPONSE_SUCCESS_HISTORY() {
    return `[${this.type}][Response][Success] Get History`;
  }
  get RESPONSE_FAIL_HISTORY() {
    return `[${this.type}][Response][Fail] Get History`;
  }

  /**
   * Differs from `Requestcount` as this is always the total count for the org, regardless of filters
   */
  RequestTotalCount() {
    return {
      type: this.REQUEST_TOTAL_COUNT,
    };
  }

  /**
   * Differs from `ResponseSuccessCount` as this is always the total count for the org, regardless of filters
   */
  ResponseSuccessTotalCount(payload: number) {
    return {
      type: this.RESPONSE_SUCCESS_TOTAL_COUNT,
      payload,
    };
  }

  ResponseFailTotalCount(payload: any) {
    return {
      type: this.RESPONSE_FAIL_TOTAL_COUNT,
      payload,
    };
  }

  PromptCreate() {
    return {
      type: this.PROMPT_CREATE,
    };
  }

  PromptEdit(payload: AnnouncementDto) {
    return {
      type: this.PROMPT_EDIT,
      payload,
    };
  }

  PromptDelete(payload: AnnouncementDto) {
    return {
      type: this.PROMPT_DELETE,
      payload,
    };
  }

  // Custom save actions to handle existing files and new files
  RequestSaveAction(payload: {
    id: string;
    data: AnnouncementDto;
    body: AnnouncementRequest;
  }): PayloadAction {
    return {
      type: this.REQUEST_SAVE,
      payload,
    };
  }

  requestLogView = createAction(this.REQUEST_LOG_VIEW, props<{ announcementId: string }>());

  responseSuccessLogView = createAction(
    this.RESPONSE_SUCCESS_LOG_VIEW,
    props<{ announcementId: string }>()
  );

  responseFailLogView = createAction(
    this.RESPONSE_FAIL_LOG_VIEW,
    props<{ announcementId: string; error: any }>()
  );

  RequestHistory = createAction(this.REQUEST_HISTORY, props<{ announcementId: string }>());

  ResponseSuccessHistory = createAction(
    this.RESPONSE_SUCCESS_HISTORY,
    props<{ announcementId: string; history: ModelEventDto[] }>()
  );

  ResponseFailHistory = createAction(
    this.RESPONSE_FAIL_HISTORY,
    props<{ announcementId: string; error: any }>()
  );

  constructor() {
    super(`Announcements`);
  }
}
export const Announcements = new AnnouncementActions();
